<template>
  <model-table
    ref="modelTable"
    title="Modifiers"
    :collection="modifiersCollection"
    submodel
    orderable
    :show-add="$isPermitted($permissions?.Concession?.Manage)"
    :columns="[
      { field: 'id' },
      { field: 'name' },
      { field: 'price', component: 'money' },
      { field: 'cost', component: 'money' },
      { name: 'salesChannels', field: (modifier) => $_.map($mh.objectToArray(modifier.salesChannels), channel => $_.startCase(channel)), component: 'chips', limitValues: 4 },
      { field: 'salesDisabled', component: 'checkmark-or-negative', label: 'Disable Sales' },
      ...(currentSite.activeInventoryStrategy && modifierSet.isRemote ? [
        { name: 'hasRecipe', field: 'trackStock', component: 'checkmark-or-negative', label: 'Track Stock' }
      ] : []),
      { name: 'archived', field: 'archivedAt', component: 'checkmark-or-negative', label: 'Archived' },
      { name: 'library', component: 'library-link', hide: currentCircuit.isLibrary },
      { name: 'actions', align: 'right' }
    ]"
    emit-only-add
    show-archived
    @add="model => $refs.selectModifiersDialog.show(model)"
    @reorder="handleModifierReorder"
  >
    <modifier-form
      ref="modifierForm"
      disable-modifier-sets
    />
  </model-table>
  <select-modifiers-dialog
    ref="selectModifiersDialog"
    :modifier-set="modifierSet"
    @create-modifier="model => $refs.modifierForm.$refs.form.show(model)"
  />
</template>

<script>
import Model from 'src/models/model'
import ModifierCollection from 'src/models/modifier-set/ModifierCollection'
import ModifierSet from 'src/models/modifier-set/ModifierSet'
import ModelTable from 'src/modules/admin/components/ModelTable'
import ModifierForm from 'src/modules/admin/modifier/ModifierForm'
import SelectModifiersDialog from 'src/modules/admin/modifier-set/SelectModifiersDialog'

export default {
  name: 'ModifierSetModifierTable',
  components: {
    ModelTable,
    ModifierForm,
    SelectModifiersDialog
  },
  configuration: ['currentCircuit', 'currentSite', 'modifiers'],
  props: {
    modifierSet: {
      type: ModifierSet,
      required: true
    }
  },
  data () {
    return {
      modifiersCollection: null
    }
  },
  watch: {
    'modifierSet.modifiers.data': {
      handler (newData) {
        if (this.modifiersCollection && typeof this.modifiersCollection.destroy === 'function') {
          this.modifiersCollection.destroy()
        }

        this.modifiersCollection = new ModifierCollection(newData, this.modifierSet)
      },
      immediate: true
    }
  },
  beforeUnmount () {
    // Clean up the collection to prevent memory leaks
    if (this.modifiersCollection && typeof this.modifiersCollection.destroy === 'function') {
      this.modifiersCollection.destroy()
    }
    this.modifiersCollection = null
  },
  methods: {
    async handleModifierReorder ({ reorderedList, orderField = 'displayOrder' }) {
      // For the many-to-many relationship between ModifierSet and Modifier,
      // we send the modifierSet ID and the reordered array of modifier IDs
      // to let the backend handle updating the ModifierSetModifier join table
      this.modifierSet.loading = true

      try {
        const modifierIds = reorderedList.map(modifier => modifier.id)

        const results = await this.modifierSet.updateModifierOrder(modifierIds)

        if (!_.isEmpty(results.errors)) {
          this.$mh.error('Failed to update modifier order:', results.errors)
        } else {
          this.modifierSet.data.modifierIds = modifierIds
        }

        // Validate the configuration to ensure everything is in sync (not awaited because it's slow)
        Model.configuration.validate()
      } catch (error) {
        this.$mh.error('Error in handleModifierReorder:', error)
        throw error
      } finally {
        this.modifierSet.loading = false
      }
    }
  }
}
</script>
